<template>
  <main class="page pto">
    <AppBack />

    <AppPageHeader title="ППР" />

    <section class="section page__content">
      <ThePagePreloader
        v-if="isLoading"
        position="component"
      />

      <div v-if="!isEdit && !isLoading" class="info">
        <PTOProjectTitle />

        <AppButtonSmEdit
          v-if="$store.getters.rightsPtoAll"
          class="info__btn-edit"
          title="Редактировать"
          @click.native="toggleIsEdit"
        />

        <ul class="info__list-edit">
          <PtoInfoItem
            label-text="Наименование ППР"
            :text="currentItem.name ? currentItem.name : '-'"
          />
          <PtoInfoItem
            label-text="Дата выдачи ППР"
            :text="currentItem.develop_date ? currentItem.develop_date : '-'"
          />
          <PtoInfoItem
            label-text="Разработчик ППР"
            :text="currentItem.developer ? getUserFullName(currentItem.developer) : '-'"
          />
          <PtoInfoItem
            label-text="МОЛ"
            :text="currentItem.mol ? getUserFullName(currentItem.mol) : '-'"
          />
        </ul>

        <AttachedFiles v-if="countFiles" :file-list="currentItem.files" />

        <FormEmail
          v-model="formDataEmail"
          class="info__list-edit info__list-edit--input"
          :is-sending="isSendingEmail"
          @request="sendPostEmailRequest"
        />
      </div>

      <FormPtoProjectPtoPPR
        v-if="isEdit"
        :form-data="currentItem"
        is-edit
        :is-sending="isSendingRequest"
        @request="sendPutRequest"
        @cancel="toggleIsEdit"
      />

      <AppModal
        v-if="modalEmail.isActive"
        :title="modalEmail.title"
        confirmButtonTitle="Ок"
        :confirmButtonType="modalEmail.type"
        @confirm="closeModalEmail"
        @reject="closeModalEmail"
      />
    </section>
  </main>
</template>

<script>
import AppBack from '@/components/page/AppBack.vue'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import AppPageHeader from '@/components/page/AppPageHeader'
import AttachedFiles from '@/components/page/files/AttachedFiles'
import FormPtoProjectPtoPPR from '@/components/pto/form/FormPtoProjectPtoPPR'
import PtoInfoItem from '@/components/pto/listItem/PtoInfoListItem.vue'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import FormEmail from '@/components/page/Form/FormEmail'
import AppModal from '@/components/page/modal/AppModal'

import { MIXIN_PTO_PROJECT_PAGE_UPDATE } from '@/mixins/module/pto/project/mixinPTOPageUpdate'
import { MIXIN_PAGE_SENDING_REQUEST } from '@/mixins/page/mixinPageSendingRequest'
import { MIXIN_PAGE_POST_EMAIL } from '@/mixins/page/request/mixinPagePostEmail'
import { mapActions, mapGetters } from 'vuex'
import { getUserFullName } from '@/utils/user'

export default {
  name: 'PtoProjectPtoKMDUpdate',
  components: {
    FormEmail,
    AppPageHeader,
    AppBack,
    AppButtonSmEdit,
    AttachedFiles,
    FormPtoProjectPtoPPR,
    PtoInfoItem,
    PTOProjectTitle,
    ThePagePreloader,
    AppModal
  },
  mixins: [
    MIXIN_PTO_PROJECT_PAGE_UPDATE,
    MIXIN_PAGE_SENDING_REQUEST,
    MIXIN_PAGE_POST_EMAIL
  ],
  data: () => ({
    // флаг означающий, что при сохранении необходимо отправить файлы
    putDataHasFiles: true
  }),
  computed: {
    ...mapGetters('pto/project/pto/ppr', {
      currentItem: 'getCurrentItem',
      isLoading: 'getIsLoading',
      countFiles: 'countFiles'
    })
  },
  methods: {
    ...mapActions('pto/project/pto/ppr', {
      loadOneItem: 'loadOneItem',
      updateItemAndProcessFiles: 'updateItemAndProcessFiles',
      requestEmail: 'requestEmail'
    }),
    getUserFullName
  }
}
</script>
